import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { BaseApiService } from '../../../core/base-api.service';
import { ApiResponse } from '../../api-response';
import { AlertRule, AlertRuleOptions, AlertRuleRequest } from '../models/alert.model';

/**
 * /api/v1/alert-rule — tenant alert-rule CRUD (tenant from JWT).
 * Reads are viewer-level; writes require tenant-admin.
 */
@Injectable({ providedIn: 'root' })
export class AlertRuleService extends BaseApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${this.coreApiUrl}/api/v1/alert-rule`;

  /** List rules, name-ordered. */
  getRules(): Observable<ApiResponse<AlertRule[]>> {
    return this.http.get<ApiResponse<AlertRule[]>>(this.baseUrl);
  }

  /** Rule-builder vocabulary (metrics + operators) — never hardcode these. */
  getOptions(): Observable<ApiResponse<AlertRuleOptions>> {
    return this.http.get<ApiResponse<AlertRuleOptions>>(`${this.baseUrl}/options`);
  }

  /** 409 on a duplicate name — the response message is user-facing. */
  createRule(request: AlertRuleRequest): Observable<ApiResponse<AlertRule>> {
    return this.http.post<ApiResponse<AlertRule>>(this.baseUrl, request);
  }

  updateRule(id: string, request: AlertRuleRequest): Observable<ApiResponse<AlertRule>> {
    return this.http.put<ApiResponse<AlertRule>>(`${this.baseUrl}/${id}`, request);
  }

  /** Deleting a rule also resolves its open alerts. */
  deleteRule(id: string): Observable<ApiResponse<void>> {
    return this.http.delete<ApiResponse<void>>(`${this.baseUrl}/${id}`);
  }
}
